import "../../../assets/mice/js/owl.carousel.js";

import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
  Input
} from "@angular/core";
import { GalleryList, GalleryContent } from "../../model/mice/mice.model";
import $ from "jquery";
import { UtilitiesService } from "../../services/utilities/utilities.service";
import { OnDestroy } from "@angular/core";
import { imgUrl } from "environments/properties";

@Component({
  selector: "act-gallery",
  templateUrl: "./gallery.component.html",
  styleUrls: ["./gallery.component.scss"]
})
export class GalleryComponent implements OnInit, AfterViewInit, OnDestroy {
  galleryItems: GalleryList = new GalleryList();
  @Input("galleryItems") set _galleryItems(value: GalleryList) {
    if (value) {
      this.galleryItems = value;
      this.initCarousel();
    }
  }
  @Input() lang: string;
  modalGallery: GalleryContent;
  modalGalery: GalleryContent;
  owlCarousel: any;
  imangePath = imgUrl + "/mice/gallery/";
  modalSlideIndex = 0;
  showModalSlide = false;
  setTimeOut = null;
  isHidden = true;

  ngAfterViewInit(): void {
    this.initCarousel();
  }

  constructor(
    private elementRef: ElementRef,
    private utilitiesService: UtilitiesService
  ) {}

  ngOnInit() {}

  initCarousel() {
    clearTimeout(this.setTimeOut);
    this.setTimeOut = setTimeout(() => {
      this.owlCarousel = $(".owl-carousel");
      this.owlCarousel.owlCarousel({
        loop: true,
        nav: false,
        center: true,
        onInitialized: onInitialized,
        onTranslate: onTranslate,
        onTranslated: onTranslated,
        navText: ["", ""],
        responsive: {
          0: {
            items: 1,
            nav: false,
            touchDrag: true
          },
          492: {
            items: 3,
            nav: true,
            dots: false,
            autoWidth: true,
            mouseDrag: false,
            touchDrag: false
          }
        }
      });

      this.isHidden = false;
      function onInitialized(event) {}
      function onTranslate(event) {
        $(".owl-next").attr("disabled", true);
        $(".owl-prev").attr("disabled", true);
      }
      function onTranslated(event) {
        $(".owl-next").attr("disabled", false);
        $(".owl-prev").attr("disabled", false);
      }
      var self = this;
      $(".owl-carousel").on("click", ".owl-item.cloned", function(event) {
        const cloneNodeId: string =
          event.currentTarget.childNodes[0].childNodes[1].id;
        const splipId = cloneNodeId.split("-");
        self.openModal(splipId[2]);
      });
    }, 3000);
  }

  setDetailByLanguage(lang) {}

  openModal(index) {
    this.modalGalery = this.galleryItems.data[index];
    if (this.modalGalery) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      this.showModalSlide = true;
      this.modalSlideIndex = 0;
      this.modalCurrentSlide(this.modalSlideIndex);
    }
  }

  refreshOwlCarousel() {
    this.owlCarousel && this.owlCarousel.trigger("destroy.owl.carousel");
    this.initCarousel();
  }

  closeModal() {
    document.getElementsByTagName("body")[0].style.overflow = "inherit";
    this.showModalSlide = false;
  }

  modalPlusSlides(n) {
    this.modalSlideIndex = this.modalSlideIndex + n;
    if (this.modalSlideIndex >= this.modalGalery.gallery.length) {
      this.modalSlideIndex = 0;
    }
    if (this.modalSlideIndex < 0) {
      this.modalSlideIndex = this.modalGalery.gallery.length - 1;
    }
  }

  modalCurrentSlide(n) {
    this.modalSlideIndex = n;
  }

  ngOnDestroy() {
    this.owlCarousel && this.owlCarousel.trigger("destroy.owl.carousel");
    clearTimeout(this.setTimeOut);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gallery/gallery.component.ts